// Force user facilities refresh on mount
import { useSelector } from 'react-redux';
import { selectUserFacilities } from '../redux/slices/facilitiesSlice';

export function useRefreshUserFacilities() {
  const userFacilities = useSelector(selectUserFacilities);
  
  // dispatch(fetchUserFacilities()); // Removed: now loaded centrally in AuthContext
  
  return { userFacilities };
} 
